import { tokenParser } from '../../../../helpers/auth';
import { localStorageService } from '../../../../services/localstorage';
import { LOCALSTORAGE_FIRSTLOGIN_PAGE } from '../../../../constants/localStorageKeys';
import { PK_PERMISSION_ROLE_PROP_NAME } from '../../../../services/permission/src/constants/permissions';

/**
 * Returns PK_PermissionRole value from encoded identity value
 * @param {string} identity - base64 encoded Identity
 * @returns {number|null} PK_PermissionRole value
 *
 * @example
 * input: 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
 * output: 5
 * */
export const extractPkPermissionRoleFromIdentify = (identity) => {
    const { PK_PermissionRole } = tokenParser(identity);

    return PK_PermissionRole;
};

/**
 * Returns Firstlogin Page auth payload based on PK_PermissionRole value
 * @param {number} pkPermissionRole - PK_PermissionRole value
 * @returns {object} FirstLogin page auth payload
 * */
export const buildFirstLoginAuthPayloadByPkPermissionRole = (pkPermissionRole) => {
    return { [PK_PERMISSION_ROLE_PROP_NAME]: pkPermissionRole };
};

/**
 * Returns FirstLogin page config based on Identity value
 * @param {string} identity - account's Identity
 * @returns {object} FirstLogin page auth payload
 * */
export const buildFirstLoginAuthPayloadByIdentity = (identity) => {
    const pkPermissionRole = extractPkPermissionRoleFromIdentify(identity);

    return buildFirstLoginAuthPayloadByPkPermissionRole(pkPermissionRole);
};

/**
 * Writes FirstLogin page config to Local Storage based on Identity value
 * @param {string} identity - account's Identity
 * @returns {object} FirstLogin page config
 * */
export const writeFirstLoginConfig = (identity) => {
    const config = buildFirstLoginAuthPayloadByIdentity(identity);
    localStorageService.setLocalStorage(LOCALSTORAGE_FIRSTLOGIN_PAGE, JSON.stringify(config));

    return config;
};

/**
 * Returns FirstLogin page config based on Identity value.
 * @returns {object} FirstLogin page config
 *
 * @examples
 * For partner:
 * {PK_PermissionRole: 5}
 *
 * For installer:
 * {PK_PermissionRole: 7}
 *
 * For end user:
 * {PK_PermissionRole: 10}
 * */
export const readFirstLoginConfig = () => {
    try {
        const configStr = localStorageService.getLocalStorage(LOCALSTORAGE_FIRSTLOGIN_PAGE);

        // could be empty or malformed value
        return JSON.parse(configStr);
    } catch (err) {
        return null;
    }
};

/**
 * Removes FirstLogin page config to Local Storage based on Identity value
 * @returns {void}
 * */
export const removeFirstLoginConfig = () => {
    return localStorageService.removeLocalStorage(LOCALSTORAGE_FIRSTLOGIN_PAGE);
};
